import { Component, OnInit } from '@angular/core';

import { ModalService } from '../shared/modal/modal.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';

import Utils from '../shared/utility';

@Component({
  selector: 'app-marketing-material',
  templateUrl: './marketing-material.component.html',
  styleUrls: ['./marketing-material.component.css']
})
export class MarketingMaterialComponent implements OnInit {
  public healthCareMaterial: any[];
  public longTermCareMaterial: any[];
  public socialSecurityMaterial: any[];

  public articlesForClients: any[];
  public clientLetters: any[];
  public educationalWorkshops: any[];
  public factGuides: any[];
  public otherAdvertising: any[];
  public websiteArtwork: any[];

  public marketingMaterialArr: any[];

  public toggleInput: any;

  public selectedCategory: any;
  public selectedDescription: any;
  public selectedTitle: any;

  public selectedInputs: any = {};

  public error: any;

  public droppedData: any = {};

  // TODO: REMOVE THIS LATER
  public visible: boolean = false;

  public modalSubscription: any;

  constructor(private modalService: ModalService, private globalService: GlobalService, private snackBarService: SnackBarService) {
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'upload-docClosed') {
        this.getMM();
      }
    });
  }

  uploadDoc() {
    const categories = this.marketingMaterialArr.reduce((arr, item, i) => { arr.push({value: item.category, title: item.category, idx: i});  return arr }, []);
    this.modalService.add('upload-doc', { Data: { arr: this.marketingMaterialArr, section: 'marketing-material', categories }, ID: Number(localStorage.getItem("userId")) });
  }

  deleteCategory(){
    this.confirmCategoryDeleteVisible = true;
    this.marketingMaterialArr.splice(this.selectedMaterial.index, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);
    this.closeCategoryDelete();

    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Category and documents have been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  deleteDoc() {
    this.marketingMaterialArr[this.selectedMaterial.i].items.splice(this.selectedMaterial.j, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);
    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Document has been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  public confirmDeleteVisible: boolean;
  public confirmCategoryDeleteVisible: boolean;
  public selectedMaterial: any;

  deleteItem(item, i, j) {
    this.selectedMaterial = {
      item,
      i,
      j
    }

    this.confirmDeleteVisible = true;
  }

  close() {
    this.confirmDeleteVisible = false;
  }

  closeCategoryDelete() {
    this.confirmCategoryDeleteVisible = false;
  }

  getMM() {
    this.globalService.GetMarketingMaterial()
      .subscribe(
        data => {

          let documents = Utils.convertMarketingMaterialOrInfoCenterToNewFormat(JSON.parse(data.data));
          
          let uniqueDocumentCategories = documents.reduce((obj, item) => {
            if (!obj[item.Category])
              obj[item.Category] = item.Category;
            return obj;
          }, {});

          this.marketingMaterialArr = [];
          this.droppedData = {};
          
          Object.keys(uniqueDocumentCategories).forEach((category, i) => {
            this.marketingMaterialArr.push({
              category: category,
              items: documents.filter(doc => doc.Category === category),
            });
            if (this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0] && (!this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0].Title || !this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0].Description)) {
              if (this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items.length > 1) {
                this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items.splice(0, 1);
              }
            }
          });

          this.generateSelectedInputs();
        },
        error => this.error = <any>error);
  }

  generateSelectedInputs() {
    this.selectedInputs = {};

    Object.keys(this.marketingMaterialArr).forEach((cat, i) => {
      this.selectedInputs[i] = { category: false }
    });

    this.marketingMaterialArr.forEach((cat, i) => {
      cat.items.forEach((doc, j) => {
        this.selectedInputs[i][j] = { title: false, description: false }
      });
    });
  }

  saveMM() {

    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);
    
    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Your document has been updated', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  public userType: any;
  public rootLevelOrganization:  boolean;

  ngOnInit() {
    this.userType = Number(localStorage.getItem('roleId')) || 3;
    this.visible = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.rootLevelOrganization = (Number(localStorage.getItem('parentID')) == 0) && (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2);
    
    this.toggleInput = {
      category: {},
      title: {},
      description: {},
    }

    this.getMM();
  }


  public addCategoryVisible: boolean = false;
  public newCategory: string = '';

  addCategory(category) {
    this.addCategoryVisible = true;
  }

  saveNewCategory() {
    this.marketingMaterialArr.unshift({
      category: this.newCategory.trim(),
      items: [],
    });

    this.newCategory = '';
    this.generateSelectedInputs();
    this.closeCategoryWindow();
    this.saveMM();
  }

  closeCategoryWindow() {
    this.addCategoryVisible = false;
  }

  delTextV2(cat, val, catIdx, docIdx, isSaving) {
    //console.log('delete cat ' + cat);
    //console.log('CAT:', this.marketingMaterialArr[catIdx].category);

    //console.log('CAT ITEMS:', this.marketingMaterialArr[catIdx].items);
      // console.log('Selected Cat:', this.selectedCategory);
       // console.log('selecteed cat items:', this.infoCenterArr[catIdx].items);//this.infoCenterArr[this.selectedMaterial.i].items

      // var thisList = this.marketingMaterialArr[catIdx].items.splice(catIdx, 1);
      // console.log('new list:', thisList);
  }

  removeCategory(cat, index) {
    this.confirmCategoryDeleteVisible = true;
    this.selectedMaterial = {
      category: cat,
      index,
    }
  }

  editTextV2(cat, val, catIdx, docIdx, isSaving) {
    if (isSaving) {
      if (cat === 'category') {
        this.selectedInputs[catIdx].category = false;
        this.marketingMaterialArr[catIdx].category = this.selectedCategory;
      } else if (cat === 'title') {
        this.selectedInputs[catIdx][docIdx].title = false;
        this.marketingMaterialArr[catIdx].items[docIdx].Title = this.selectedTitle;
      } else if (cat === 'description') {
        this.selectedInputs[catIdx][docIdx].description = false;
        this.marketingMaterialArr[catIdx].items[docIdx].Description = this.selectedDescription;
      }
      this.saveMM();
    } else {
      if (cat === 'category') {
        this.selectedInputs[catIdx].category = true;
        this.selectedCategory = val;
      } else if (cat === 'title') {
        this.selectedInputs[catIdx][docIdx].title = true;
        this.selectedTitle = val;
      } else if (cat === 'description') {
        this.selectedInputs[catIdx][docIdx].description = true;
        this.selectedDescription = val;
      }
    }
  }

  onDrop(event, catIdx, docIdx) {

    if (!this.parentTableTriggered && catIdx === event.dropData.catIdx) {
      var fromDoc = this.marketingMaterialArr[event.dropData.catIdx].items[event.dropData.docIdx];
      var toDoc = this.marketingMaterialArr[catIdx].items[docIdx];
      this.marketingMaterialArr[event.dropData.catIdx].items[event.dropData.docIdx] = toDoc;
      this.marketingMaterialArr[catIdx].items[docIdx] = fromDoc;
    }

    this.parentTableTriggered = false;

    this.generateSelectedInputs();
    this.saveMM();
  }

  public parentTableTriggered: boolean = false;
  public triggeredIndex: any = 0;

  onDropTable(event, catIdx, docIdx) {
    this.marketingMaterialArr[event.dropData.catIdx].items.splice(event.dropData.docIdx, 1);
    this.marketingMaterialArr[catIdx].items.push(event.dropData.item);

    if (!this.marketingMaterialArr[catIdx].items[0].Title || !this.marketingMaterialArr[catIdx].items[0].Description) {
      this.marketingMaterialArr[catIdx].items.splice(0, 1);
      this.parentTableTriggered = true;
    }

    this.generateSelectedInputs();
    this.saveMM();
  }
}
